import {s, filter, lazy} from './lang.js';
import {t_len} from './tlist.js';
import {j_tidal, tidal} from './tidal.js';


export const isNewCycle = () => {
  return (...args) => {
    return filter(
      !args[0] || args[0].isNewCycle);
  };
};

export const t_every = (n, action, debug) => {
  let count = 0;
    return (...args) => {
        let _n = lazy(n, ...args);
        let _isNewCycle = args[0] && args[0].isNewCycle;
        if (_isNewCycle) {
            count++;      
            if (count % _n === 0) {
                return lazy(action, ...args);
            }
        }
        
        return filter(true);
    };
};

// swaps the last 2 figures (should be used in conjuction w t_every to
// introduce variations periodically, based on the cycle
export const t_variation = (pattern, a=1, b=2) => {
  return (...args) => {
    let _p = lazy(pattern, ...args);
    let _a = lazy(a, ...args);
    let _b = lazy(b, ...args);
    // break up by figures
    let figures = [];
    let figure = [];
    let last = undefined;
    for (let term of _p) {
      if (last && term.figureId !== last.figureId) {
        figures.push(figure);
        figure = [];
      }
      figure.push(term);
      last = term;
    }
    figures.push(figure);
    
    let fnum = figures.length;
    let tmp = figures[fnum - b];
    figures[fnum - b] = figures[fnum - a];
    figures[fnum - a] = tmp;
    return figures.reduce((a,b) => [...a, ...b], []);
  };
};

export const vary_every = (pattern, e_times=2, transform, tempo) => {
    transform = transform || ((a) => () => a);
    let mutate = () => {
    pattern = t_variation(pattern);
    return filter(true);
  };

  return {
    pattern: () => transform(pattern())(),
    player: s( 
        t_every(e_times, mutate))
  };
};

export const play_and_vary = (pattern, e_times=2, transform, tempo) => {
    transform = transform || ((a) => () => a);
    let mutate = () => {
    pattern = t_variation(pattern);
    return filter(true);
  };
  return {
    pattern: () => transform(pattern())(),
    player: s( 
        j_tidal(() => transform(pattern())(), tempo),
        t_every(e_times, mutate))
  };
};
